module.exports = __webpack_public_path__ + "012cf6a10129e2275d79d6adac7f3b02.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/material-icons/MaterialIcons-Regular.woff
// module id = 375
// module chunks = 134